require('./cardPINChangeView.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
//@actions
const CardPINChange = require('actions/cardPINChange');
//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
//@components
const CardPINChangeError = require('components/cards/cardPINChange/cardPINChangeError/cardPINChangeError');
const CardPINChangeInputs = require('components/cards/cardPINChange/cardPINChangeInputs/cardPINChangeInputs');
const CardPINChangeStep = require('components/cards/cardPINChange/cardPINChangeStep/cardPINChangeStep');
const CardPINChangeSuccess = require('components/cards/cardPINChange/cardPINChangeSuccess/cardPINChangeSuccess');
//@utilities
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
//@constants
const { CARD_PIN_CHANGE } = require('constants/operationTypes');

class CardPINChangeView extends React.Component {

    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_PIN_CHANGE, { immCard }, history);
    }

    componentWillUnmount() {
        this.props.resetView();
    }

    buildError(immCard) {
        return (
            <div className="card-pin-change-view__operation-result-state">
                <CardPINChangeError immCard={immCard} />
            </div>
        );
    }

    buildSuccess(immCard) {
        return (
            <div className="card-pin-change-view__operation-result-state">
                <CardPINChangeSuccess immCard={immCard} />
            </div>
        );
    }

    buildWizard(immCard, immMinicardChangePIN) {
        const { setVisibleStep, setNewPin, setNewPinConfirmation, validateStep } = this.props;
        const immSteps = immMinicardChangePIN.get('steps');
        const actions = {
            finish: this.handleFinish,
            setVisibleStep,
            setWillCancel: this.handleCancel,
            validateStep
        };
        const operationParams = {
            pan: immCard.get('number').replace(/\s/g, '')//deletes spaces from card number.
        };

        return (
            <Wizard
                actions={actions}
                fullWidth={true}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immMinicardChangePIN.get('visibleStep')}
                showPreLeaveModal={true}
            >
                <WizardStep position="first" cancelButton={true} >
                    <CardPINChangeStep immCard={immCard} titleKey="cardMinicardPinChangeStep-titleStep1">
                        <CardPINChangeInputs
                            setNewPin={setNewPin}
                            setNewPinConfirmation={setNewPinConfirmation}
                            immMinicardChangePIN={immMinicardChangePIN}
                        />
                    </CardPINChangeStep>
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    cancelButton={true}
                    immFinalButton="cardPinChange-cardPinChange_finalStepButton"
                    position="last"
                >
                    <CardPINChangeStep immCard={immCard} titleKey="cardMinicardPinChangeStep-titleStep2">
                        <div className="card-pin-change-view__signature-pattern">
                            <SignaturePattern
                                operationParams={operationParams}
                                operationType={CARD_PIN_CHANGE}
                            />
                        </div>
                    </CardPINChangeStep>
                </WizardStep>
            </Wizard>
        );
    }

    handleCancel() {
        const { history, match: { params: { cardId } } } = this.props;
        history.push(`/myprofile/cards/${cardId}/details`);
    }

    handleFinish() {
        const { requestPinChange, match: { params: { cardId } } } = this.props;
        requestPinChange(cardId);
    }

    render() {
        const { match: { params: { cardId } }, immCards, immMinicardChangePIN } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        let content;

        if (immCard) {
            let bodyContent;

            if (immMinicardChangePIN.get('error')) {
                bodyContent = this.buildError(immCard);
            } else if (immMinicardChangePIN.get('success')) {
                bodyContent = this.buildSuccess(immCard);
            } else {
                bodyContent = this.buildWizard(immCard, immMinicardChangePIN);
            }

            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.getIn(['alias', 'current']),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('breadcrumb-breadcrumb_PinChange'),
                    url: `/myprofile/cards/${cardId}/pin-change`
                }
            ];

            content = (
                <article className="card-pin-change-view">
                    <OKCover size="medium" section="cards">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('cardPinChange-cardPinChange_title')}
                        />
                    </OKCover>
                    <section className="card-pin-change-view__body">
                        {bodyContent}
                    </section>
                </article>
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }
}

CardPINChangeView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immMinicardChangePIN: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    requestPinChange: PropTypes.func.isRequired,
    setNewPin: PropTypes.func.isRequired,
    setNewPinConfirmation: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    resetView: PropTypes.func.isRequired
};

module.exports.constructor = CardPINChangeView;
module.exports.CardPINChangeView = connect(state => ({
    immCards: state.cards,
    immMinicardChangePIN: state.cardPinChange
}),
    {
        requestPinChange: CardPINChange.requestPinChange,
        setNewPin: CardPINChange.setNewPin,
        setNewPinConfirmation: CardPINChange.setNewPinConfirmation,
        setVisibleStep: CardPINChange.setVisibleStep,
        validateStep: CardPINChange.validateStep,
        resetView: CardPINChange.resetView
    })(withRouter(CardPINChangeView));
